import React from "react";
import { StyleSheet } from 'react-native';
import Text from "theme/Text";


const Title = ( { children, style = {} } ) => {
	
	return (
		<Text
			category='h3'
			style={[ styles.text, style ]}>
			
			{ children }
		</Text>
	)
}

const styles = StyleSheet.create({
	text: { marginBottom: 10 },
});

export default Title;
